<template>
  <div :id="id" class="container report-form">
    <div class="row  mb-2" v-if="form.finalized">
      <div class="col">
        <button
          class="btn d-block btn-primary float-right mx-1"
          @click="$emit('print')"
          v-if="shouldShowReportPrint"
        >
          {{ $t('smartChart.printReport') }}
        </button>
        <button
          class="btn d-block btn-primary float-right"
          @click="$emit('generateRecord')"
          v-if="shouldShowReportPrint"
        >
          {{ $t('smartChart.generateRecord') }}
        </button>
      </div>
    </div>
    <div
      v-for="(line, lineIdx) in source"
      :key="lineIdx"
      :class="
        `tik_${tik} form__element row form-group  ${
          gutters ? '' : 'no-gutters'
        }  mb-2`
      "
    >
      <ReportFormWidget
        v-for="(element, elementIdx) in line"
        :key="elementIdx"
        :name="name"
        :element="element"
        :viewing="viewing"
        :elementIdx="elementIdx"
        :value="form[element.name]"
        :linkedValue="form[`${element.name}Others`]"
        @change="(v, n, e) => $emit('value-change', v, n, e)"
        :isPrint="isPrint"
        :finalized="form.finalized"
      ></ReportFormWidget>
    </div>

    <div class="row" v-if="!form.finalized">
      <div class="col"></div>
      <div class="col-auto text-center">
        <b-button
          variant="primary"
          class="h-85"
          @click="showUploadModal = true"
        >
          {{ viewing ? $t('smartChart.uploadedImages') : $t('general.upload') }}
        </b-button>
        <b-button
          variant="primary"
          class="h-85 mx-2"
          @click="$emit('save')"
          v-if="!viewing"
        >
          {{ $t('general.save') }}
        </b-button>
        <b-button
          variant="primary"
          class="h-85"
          @click="$emit('publish')"
          v-if="!viewing"
        >
          {{ $t('general.publish') }}
        </b-button>
      </div>
      <div class="col"></div>
    </div>
    <b-modal
      v-if="!form.finalized"
      v-model="showUploadModal"
      @ok="hideUploadModal"
      @hide="hideUploadModal"
      :title="$t('smartChart.uploadImage')"
      modal-class="chart__upload__image"
      hide-footer
    >
      <div class="config-container container" v-if="!viewing">
        <UploadImageInlineForm
          v-for="img in formImages"
          :key="img._id"
          :reportPk="form.caseID"
          :reportType="reportType"
          :defaultComment="img.comment || ''"
          :imagePk="img._id"
          :imageURL="img.signedURL"
          :reportFinalized="form.finalized"
          @images-updated="$emit('images-updated')"
        ></UploadImageInlineForm>
        <UploadImageInlineForm
          :reportPk="form.caseID"
          v-for="(_, idx) in 10 - formImages.length"
          :key="`blk_${idx}`"
          :reportType="reportType"
          @images-updated="$emit('images-updated')"
        ></UploadImageInlineForm>
      </div>
      <div class="config-container container" v-else>
        <UploadImageInlineForm
          v-for="img in formImages"
          :key="img._id"
          :reportPk="form.caseID"
          :reportType="reportType"
          :defaultComment="img.comment || ''"
          :imagePk="img._id"
          :imageURL="img.signedURL"
          :reportFinalized="form.finalized"
          @images-updated="$emit('images-updated')"
        ></UploadImageInlineForm>
      </div>
    </b-modal>
    <div class="form__images" v-if="form.finalized || isPdf || isPrint">
      <div
        class="image__item media form__element"
        v-for="image in formImages"
        :key="image._id"
        @click="showLargeImage(image)"
      >
        <img
          class="mr-3"
          v-if="image && image.signedURL && isPdf"
          :src="image.url"
          :alt="image.comment"
          crossorigin="anonymous"
        />
        <img class="mr-3" :src="image.signedURL" :alt="image.comment" v-else />
        <div class="media-body">
          <b-form-textarea
            :value="image.comment"
            disabled
            readonly
            v-if="!isPrint"
          ></b-form-textarea>
          <p class="as__textarea min__95" v-else>{{ image.comment }}</p>
        </div>
      </div>
    </div>
    <b-modal v-model="showLargeModal" ok-only>
      <div class="large__preview" v-if="selectedImage">
        <img :src="selectedImage.signedURL" />
        <p class="as__textarea min__95">{{ selectedImage.comment }}</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ReportFormWidget from './ReportFormWidget.vue';
import UploadImageInlineForm from './UploadImageInlineForm.vue';

export default {
  name: 'BaseReportForm',
  components: {
    ReportFormWidget,
    UploadImageInlineForm,
  },
  props: {
    name: {
      type: String,
    },
    id: {
      type: String,
    },
    cls: {
      type: String,
    },
    source: {
      type: Array,
    },
    viewing: {
      type: Boolean,
      default: false,
    },
    form: Object,
    formImages: null,
    reportType: null,
    tik: null,
    isPrint: {
      type: Boolean,
      default: false,
    },
    shouldShowReportPrint: {
      type: Boolean,
      default: false,
    },
    isPdf: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showUploadModal: false,
      selectedImage: null,
      showLargeModal: false,
      gutters: false,
    };
  },
  methods: {
    getClass(element) {
      let className = '';
      if (element.display === 'hide') className += 'd-none';
      if (element.required) className += 'col-form-label-required';
      if (element.class) className += `${element.class}`;
      return className;
    },
    hideUploadModal() {
      this.showUploadModal = false;
    },
    showLargeImage(image) {
      if (this.isPrint) return;
      this.selectedImage = image;
      this.showLargeModal = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.report-form {
  width: 750px;
  .input-group-text {
    padding: 0.25rem;
  }
  .form__element {
    label {
      font-size: smaller !important;
    }
  }
  .el-input__inner {
    padding: 0 0 0 15px;
  }
}
.form__images {
  .image__item {
    margin-bottom: 2rem;
    cursor: pointer;
    img {
      width: 95px;
      height: 95px;
    }
    textarea {
      min-height: 95px;
    }
  }
}
.large__preview {
  img {
    width: 100%;
    height: auto;

    max-width: 100%;
    max-height: 100%;
  }
}
</style>
